export default __webpack_public_path__ + "static/media/paw-print.769a086d.svg";